import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import api from "../../services/api";

const DriverProfile = () => {
  const [form, setForm] = useState({
    license_number: "",
    truck_id: "",
    chassis_id: "",
    contact_name: "",
    contact_phone: "",
  });
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    const token = localStorage.getItem("token");
    if (!token) {
      setError("You are not logged in. Please log in and try again.");
      setIsLoading(false);
      return;
    }

    try {
      await api.post("/profile/complete-profile/driver", form);
      navigate("/dashboard");
    } catch (err) {
      const axiosErr = err as AxiosError<{ message?: string }>;
      setError(
        axiosErr.response?.data?.message ||
          "Network error. Please check your connection and try again.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 max-w-md mx-auto p-6">
      <h2 className="text-2xl font-bold">Complete Driver Profile</h2>

      <div aria-live="polite" aria-atomic="true">
        {error && (
          <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm text-red-600">{error}</p>
          </div>
        )}
      </div>

      <div>
        <label htmlFor="license_number" className="block text-sm font-medium text-gray-700 mb-1">License Number</label>
        <input id="license_number" type="text" name="license_number" placeholder="Enter license number\u2026" onChange={handleChange} required className="w-full border rounded px-3 py-2" />
      </div>
      <div>
        <label htmlFor="truck_id" className="block text-sm font-medium text-gray-700 mb-1">Truck ID</label>
        <input id="truck_id" type="text" name="truck_id" placeholder="Enter truck ID\u2026" onChange={handleChange} required className="w-full border rounded px-3 py-2" />
      </div>
      <div>
        <label htmlFor="chassis_id" className="block text-sm font-medium text-gray-700 mb-1">Chassis ID</label>
        <input id="chassis_id" type="text" name="chassis_id" placeholder="Enter chassis ID\u2026" onChange={handleChange} required className="w-full border rounded px-3 py-2" />
      </div>
      <div>
        <label htmlFor="driver_contact_name" className="block text-sm font-medium text-gray-700 mb-1">Contact Name</label>
        <input id="driver_contact_name" type="text" name="contact_name" autoComplete="name" placeholder="Enter contact name\u2026" onChange={handleChange} required className="w-full border rounded px-3 py-2" />
      </div>
      <div>
        <label htmlFor="driver_contact_phone" className="block text-sm font-medium text-gray-700 mb-1">Contact Phone</label>
        <input id="driver_contact_phone" type="tel" name="contact_phone" autoComplete="tel" placeholder="Enter contact phone\u2026" onChange={handleChange} required className="w-full border rounded px-3 py-2" />
      </div>
      <button type="submit" disabled={isLoading} className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700 disabled:opacity-50">
        {isLoading ? "Submitting\u2026" : "Submit"}
      </button>
    </form>
  );
};

export default DriverProfile;
